import Vue from 'vue'
import {
  FindActionAbilityByClassSku,
} from "@/axios/IDevice.js";
import {
  fillCheckeddata,
} from "@/page/control-ts/scene/sceneHandle/indexFns";
import {getSenceShowMode} from '@/utils/utils'



function getInitAction(){
  return {
    '0x02_1': {val:["0x02",false],type:1},
    '0x02_2': {val:["0x02",0],type:2},
    '0x03_1': {val:["0x03",false],type:1},
    '0x03_2': {val:["0x03",100],type:2},
    '0x03D80000,0x03DA0000,0x03840000_1':{val:[['0x03D80000', '0x03DA0000', '0x03840000'],false],type:1},
    '0x03DA00000x03840000_2':{val:["0x03DA00000x03840000",0],type:2},
    '0x04_1':{val:["0x04",false],type:1},
    '0x04_2':{val:["0x04",4200],type:2},
    '0x03880000_1':{val:[["0x03880000"],false],type:1},
    '0x03880000_2':{val:["0x03880000",0],type:2},
    '0x05,0x18_1':{val:[['0x05', '0x18'],false],type:1},
    '0x05,0x18_2':{val:[['0x05', '0x18'],'#ff0000'],type:2},
  }
};

export default class DeviceHandler {
  constructor({ deviceList, groupList }) {
    this.data = {
      parameters: {},
      isSearchKeywords: false,
      searchKeywords: '',
      deviceList, // 选择的数据
      groupList, // 群数据
      isAddDeviceLoading: false,
      groupSiftOptions: [],
      groupSiftValue: [],
      optionArryValue: [],
      checkedDeviceList: [],
      skuList: new Set(),
      skuSiftValue: [],
      skuSiftOptions: [],
      getCheckedDeviceListPromiseResolve: null,
      common_action_json: getInitAction()
    }

    this.init();
  }

  async init() {
    this.data.isAddDeviceLoading = true;

    this.initGroupSiftOptions();
    this.initDeviceList();
    this.skusiftsort();
    this.handlerUnChecked();
    await this.reqFindActionAbilityByClassSku();

    this.data.dialogGroup = false;
    this.data.isAddDeviceLoading = false;

    if (this.data.getCheckedDeviceListPromiseResolve) {
      this.data.getCheckedDeviceListPromiseResolve(
        this.data.checkedDeviceList
      );
    }
  }

  getCheckedDeviceList() {
    if (!this.data.getCheckedDeviceListPromiseResolve) {
      return new Promise((resolve, reject) => {
        this.data.getCheckedDeviceListPromiseResolve = resolve;
      });
    } else {
      return this.data.checkedDeviceList;
    }
  }

  initGroupSiftOptions() {
    const { groupList } = this.data;

    groupList.forEach((item) => {
      const groupSiftOptionsItem = this.data.groupSiftOptions.find((option) => {
        return (
          option.id == item.id &&
          option.AreaNo == item.AreaNo &&
          option.GpNo == item.GpNo
        );
      });

      if (!groupSiftOptionsItem) {
        item.checked = true;

        this.data.groupSiftOptions.push(item);

        const optionArryValueItem = this.data.optionArryValue.find((value) => {
          return (
            value.id == item.id &&
            value.AreaNo == item.AreaNo &&
            value.GpNo == item.GpNo
          );
        });

        if (!optionArryValueItem) {
          this.data.optionArryValue.push(item);
        }
      } 
    });
  }

  initDeviceList() {
    const { deviceList } = this.data;

    if (!Array.isArray(deviceList)) return;

    deviceList.forEach(item => {
      const { ClassSku } = item;

      this.data.checkedDeviceList.push({
        ...item,
        VDeviceId: item.VDeviceId,
        ChildId: item.ChildId,
        DeviceName: item.DeviceName,
        AreaName: item.AreaName,
        ChildName: item.ChildName,
        ClassSku: item.ClassSku,
        ClassSkuName: item.ClassSkuName,
        Mac: item.Mac,
        ActionList: [],
        ischeck: true,
        iscomfirm: true, //是否是新增进来的设备
      });

      this.data.skuList.add(ClassSku);
    });
  }

  skusiftsort() {
    const { checkedDeviceList } = this.data;
    let siftFindObj = null;

    this.data.skuSiftValue = [];
    this.data.skuSiftOptions = [];
    let _param;

    for (let i = 0; i < checkedDeviceList.length; i++) {
      const item = checkedDeviceList[i];

      if (!item.ClassSku) continue;

      siftFindObj = this.data.skuSiftOptions.find((option) => {
        return option.ClassSku === item.ClassSku;
      });

      if (!siftFindObj) {
        const optionValue = this.data.optionArryValue.find((value) => {
          return value.ClassSku == item.ClassSku;
        });

        if (!optionValue) {
          let insertData = {
            checked: true,
            ClassSku: item.ClassSku,
            ClassSkuName: item.ClassSkuName,
          };

          this.data.skuSiftOptions.push(insertData);
          this.data.optionArryValue.push(insertData);
        } else {
          this.data.skuSiftOptions.push(optionValue);
        }
      }
    }

    this.data.skuSiftValue = this.data.skuSiftOptions
      .filter(item => item.checked)
      .map((res) => {
        return res.ClassSku;
      });
 
    let newCheckedDeviceList = [];

    if (
      Array.isArray(this.data.skuSiftValue) &&
      this.data.skuSiftValue.length
    ) {
      this.data.checkedDeviceList.forEach((item) => {
        newCheckedDeviceList.push(item);

        siftFindObj = this.data.skuSiftValue.find((value) => {
          return value === item.ClassSku;
        });

        item.ischeck = !!siftFindObj;
      });
    } else {
      this.data.checkedDeviceList.forEach(item => {
        item.shown = true;
        item.ischeck = false;
        newCheckedDeviceList.push(item);
      });
    }

    if (
      Array.isArray(this.data.groupSiftValue) &&
      this.data.groupSiftValue.length
    ) {
      let _groupSiftOptions = [];

      this.data.groupSiftValue.forEach((param) => {

        siftFindObj = this.data.groupSiftOptions[param];

        if (
          siftFindObj &&
          Array.isArray(siftFindObj.DeviceInfos)
        ) {
          siftFindObj.DeviceInfos.forEach(info => {
            _groupSiftOptions.push(info);
          });
        }
      });

      newCheckedDeviceList.forEach((item) => {
        if (item.shown) {
          siftFindObj = _groupSiftOptions.find((option) => {
            return (
              option.ChildId == null && item.VDeviceId == option.VDeviceId ||
              option.ChildId != null &&
                item.VDeviceId == option.VDeviceId &&
                item.ChildId == option.ChildId
            );
          });

          item.ischeck = !!siftFindObj;
        }
      });

      _groupSiftOptions = null;
    }

    if (
      this.data.isSearchKeywords &&
      !!this.data.searchKeywords
    ) {
      for (let i = 0; i < newCheckedDeviceList.length; i++) {
        if (this.data.optionArryValue.length === 0)  item.ischeck = true;

        const item = newCheckedDeviceList[i];

        if (!item.ischeck) continue;
        if (this.searchKeywords.includes(' ')) {
          const searchItem = this.searchKeywords.split(' ').find((word) => {
            return (
              item.DeviceName.includes(word) ||
              item.ChildName.includes(word)
            );
          });

          if (!searchItem) {
            item.ischeck = false;
          }
        } else if (
            !item.DeviceName.includes(this.data.searchKeywords) &&
            !item.ChildName.includes(this.searchKeywords)
          ) {
            item.ischeck = false;
          }
      }
    }

    this.data.checkedDeviceList = newCheckedDeviceList.map(item => {
      // const ischeck = !!item.ischeck;
      // delete item.ischeck;
      // this.$set(item, "ischeck", ischeck);
      return {
        ...item,
        ischeck: !!item.ischeck
      };
    });
  }

  handlerUnChecked() {
    this.data.optionArryValue = [];
    this.data.skuSiftValue = [];

    const skuSet = new Set();
  
    this.data.checkedDeviceList.forEach((item) => {
      const { ClassSku, ClassSkuName, iscomfirm } = item;

      if (iscomfirm) {
        // iscomfirm 为ture 表示新增的设备
        let result = {
          checked: true,
          ClassSku,
          ClassSkuName,
        };

        if (!skuSet.has(ClassSku)) {
          skuSet.add(ClassSku);
          this.data.optionArryValue.push(result);
          this.data.skuSiftValue.push(ClassSku);
        }
      } else {
        item.data.ischeck = false;
      }
    });

    this.data.skuSiftOptions.forEach((item) => {
      const { ClassSku } = item;

      if (!skuSet.has(ClassSku)) {
        item.checked = false;
      }
    });
  }

  async reqFindActionAbilityByClassSku() {
    const { skuList } = this.data;

    try {
      const params = { classSkuList: [ ...skuList].join(',') };

      const res = await FindActionAbilityByClassSku(params);

      // let ClassSku_json = {};
      const classSkuMap = new Map();

      this.data.checkedDeviceList.forEach((item) => {
        const { ClassSku } = item;

        if (!classSkuMap.has[ClassSku]) {
          classSkuMap.set(ClassSku, []);
        }

        classSkuMap.get(ClassSku).push(item);
      });

      const { Result, StatusCode } = res;

      if (
        StatusCode === 0 &&
        Array.isArray(Result)
      ) {
        Result.forEach((item) => {
          const { ClassSku } = item;
          const classSkuList = classSkuMap.get(ClassSku);

          if (classSkuList) {
            // let list = ClassSku_json[ClassSku];
            classSkuList.forEach((skuData) => {
              const { ActionList } = skuData;
              // 初始化actionList
              if (ActionList.length === 0) {
                let action_list = this.functionfilter(
                  item.ActionList,
                  item.vDeviceId,
                  null
                );
                //避免每个设备的能力都指向一个地址
                skuData.ActionList = JSON.parse(
                  JSON.stringify(action_list)
                );

                if (params.isall) {
                  skuData.ActionList.forEach((model) => {
                    model.ischeck = true;
                  });
                }
              }
            });
          }
        });
      }

      this.data.checkedDeviceList = this.data.checkedDeviceList.map((item) => {
        // let ischeck = item.ischeck;
        // delete item.ischeck;
        // this.$set(item, "ischeck", ischeck);
        item.ActionList = JSON.parse(JSON.stringify(item.ActionList));

        return item;
      });

      this.sync_common_action();
      this.data.addDeviceDoading = false;
    } catch (e) {
      console.log('eee', e);
      
    }
  }

  sync_common_action() {
    let action_list = Object.values(this.data.common_action_json);
    let comfim_list = this.data.checkedDeviceList.filter(
      (item) => item.iscomfirm || item.ischeck
    ); //新增过来的设备列表
    console.log(".....action_list", this.common_action_json);
    action_list.forEach((item) => {
      const { val, type } = item;
      let func = type == 1 ? this.doIsjoined : this.doIssued;
      if (comfim_list.length > 0) {
        func(val, comfim_list);
      }
    });
    comfim_list.forEach((item) => item.iscomfirm = false);
  }

  /* 
    * 格式化action数据
    */
  functionfilter(arry, vDeviceId, childId, defaultOption) {
    // 筛选数组 将不显示的对象去除  DefaultValue格式化转成int
    let _obj;
    let _isLightActionAutoOpare = false;
    let _scenlist = false;

    if (!Array.isArray(arry)) return [];

    arry.forEach((model) => {
      model.ischeck = false; // 默认选中 （false为禁能2022.12.6）
      for (let i = 0; i < model.Values.length; i++) {
        if (!model.Values[i].IsShow) {
          // model.Values.splice(i, 1);
          // delete(model.Values[i]);
        } else {
          // if (this.sceneId && defaultOption) {
            // defaultOption.Rules.forEach((m) => {
            //   if (m.MsgType == model.MsgType) {
            //     model.ischeck = true; // 只显示模版中有的能力
            //     m.Values.forEach((n) => {
            //       model.Values.forEach((y) => {
            //         if (n.KeyId == y.KeyId && y.chanded != true) {
            //           // y.DefaultValue = Number(n.Value);
            //           y.DefaultValue = Number(n.DefaultValue); // 接口修改返回格式
            //         }
            //       });
            //     });
            //   }
            // });
          // }
          // if (this.scenlist && !this.sceneId) {
          //   this.scenlist.DeviceList.forEach((t) => {
          //     if (
          //       (childId == null && t.VDeviceId == vDeviceId) ||
          //       (t.VDeviceId == vDeviceId && t.ChannelId == childId)
          //     ) {
          //       _scenlist = true;
          //       t.ActionList.forEach((m) => {
          //         if (m.MsgType == model.MsgType) {
          //           this.data.parameters.SceneNo && (model.ischeck = true); // 2022.12.6 新建时默认禁止
          //           m.Values.forEach((n) => {
          //             model.Values.forEach((y) => {
          //               if (n.KeyId == y.KeyId && y.chanded != true) {
          //                 y.DefaultValue = Number(n.Value);
          //               }
          //             });
          //           });
          //         }
          //       });
          //     }
          //   });
          // }
          // 格式化slid数据
          // Vue.prototype.LightActionValueReady(model, i);
          model.Values[i].chanded = true;
          if (model.Values[i].ValueType !== "UIControl_ColorPanel") {
            model.Values[i].DefaultValue = +model.Values[i].DefaultValue;
          }
        }
      }

      if (_scenlist == false && _isLightActionAutoOpare == false) {
        // 判断添加的为调光设备 自动化开启调光和开关
        model.Values.forEach((n) => {
          if (n.Type != null && n.Type.indexOf("0x03") != -1) {
            _isLightActionAutoOpare = true;
            this.isLightActionAutoOpare = true;
          }
        });
      }
    });

    if (!this.sceneId && _isLightActionAutoOpare) {
      // 判断添加的为调光设备 自动化开启调光和开关 (2022.11.21 排除模版）
      arry.forEach((m) => {
        _obj = m.Values.find((_p) => {
          return (
            _p.Type != null &&
            (_p.Type.indexOf("0x02") != -1 || _p.Type.indexOf("0x03") != -1)
          );
        });
        if (_obj != null) {
          this.data.parameters.SceneNo && (m.ischeck = true); // 2022.12.6 新建时默认禁止
          if (_obj.Type.indexOf("0x02") != -1) {
            _obj.DefaultValue = 1; // 默认 开
          }
        }
      });
    }
    // _obj = null;
    // _isLightActionAutoOpare = null;
    // _scenlist = null;
    // ActionMap[vDeviceId] = arry;
    // return arry.map((el) => {
    //   el.orderId = getSortOrderValue(el.MsgType) || 1;
    //   return el;
    // });

    return arry
  }

   /* 统一设置 批量参与
     * val：下发的值
     * list 要处理的list数组，默认为空，处理checkeddata，有值优先list
     */
   doIsjoined = (val, list = null) => {
    this.handle_common_action_json(val, 1);
    fillCheckeddata(val, list || this.checkedDeviceList);
  }

   /* 执行设备下发
     * item action对象
     * model 色号被对象
     * _type 类型 0单个 其他多个
     */
   doCallAction(item, model, _type, isColor) {
    return
    if (this.isActionPost !== true && !this.isPreSave) {
      return;
    }
    if (invoking) {
      queue.push(() => this.doCallActionIn(item, model, _type));
    } else {
      invoking = true;
      this.doCallActionIn(item, model, _type);
    }
    // this.doCallActionIn(item,model,_type);
  }

  /* 执行设备下发
     * item action对象
     * model 色号被对象
     * _type 类型 0单个 其他多个
     */
  doCallActionIn(item, model, _type) {
    return
    if (this.isActionPost != true && !this.isPreSave) {
      return;
    }
    _type = _type || 0;
    let _values = "";

    item.Values.forEach((tem) => {
      const _temvalue = this.LightActionValueSubmit(tem);
      if (_values == "") {
        _values = _temvalue + "";
      } else {
        _values += "," + _temvalue;
      }
    });
    let para = {
      vDeviceId: model.VDeviceId,
      msgType: item.MsgType,
      channelId: model.ChildId,
      values: _values,
    };
    if (_type == 0) {
      CallAction(para, this.functionDoCallAction);
    } else {
      CallAction(para, this.functionDoCallActionMany);
    }

    para = null;
    _values = null;
  }

  /* 统一设置 批量下发
     * val：下发的值
     * list 要处理的list数组，默认为空，处理checkeddata，有值优先list
     */
  doIssued = (val, list = null) => {
    this.handle_common_action_json(val, 2);
    // 统一设置 批量下发
    let device_list = list || this.checkedDeviceList;

    device_list.forEach((n) => {
      if (n.ischeck != true) return;

      n.ActionList.filter(
        (item) => getSenceShowMode(item)
      ).forEach((m) => {
          // if(m["ischeck"] != true){return;}
        if (val[0] === "0x03DA00000x03840000") {
          if (["0x03DA0000", "0x03D80000"].includes(m.MsgType)) {
            // msgType 0x03DA0000 1-调亮 2-调暗
            m.Values[0].DefaultValue = val[1] == 0 ? 1 : 2;
            this.doCallAction(m, n, 1);
          } else if (m.MsgType == "0x03840000") {
            m.Values[0].DefaultValue = val[1];
            this.doCallAction(m, n, 1);
          }
        } else if (m.MsgType == "0x03880000") {
          m.Values[0].DefaultValue = val[1];
          this.doCallAction(m, n, 1);
        } else if (m.Values.length > 0) {
            m.Values.forEach((t) => {
              if (t.Type != null) {
                if (
                  val[0] instanceof Array &&
                    val[0].find((_val) => {
                      return t.Type.indexOf(_val) != -1;
                    }) != null ||
                  typeof val[0] === "string" &&
                    t.Type.indexOf(val[0]) != -1
                ) {
                  // if(t.Type.indexOf(val[0]) != -1 ){
                  if (val[0] == "0x02") {
                    // 2022.11.23 原代码总控和单个设备DefaultValue值不同 现共用一个ui value值相同
                    // if (val[1] == 0) {
                    //   t.DefaultValue = 1;
                    // } else {
                    //   t.DefaultValue = 0;
                    // }
                    t.DefaultValue = val[1];
                  } else {
                    t.DefaultValue = val[1];
                  }

                  // this.$store.dispatch('changeLoading', true);
                  this.doCallAction(m, n, 1);
                }
              }
            });
          }}
      );
    });
    // if (this.$store.state.isloading) {
    //   setTimeout(() => {
    //     this.$store.dispatch("changeLoading", false);
    //     alertsuccess(this, this.$store.state.rightStatusCode);
    //   }, 2000);
    // }
  }

  /**
     * 记录统一控制设备的action
     * @param {*} val 统一下发设备的action
     * @param {*} type  1 doIsjoined(批量参与)  2 doIssued(批量下发)
     */
  handle_common_action_json(val, type) {
    if (
      Array.isArray(val) &&
      val.length == 2
    ) {
      let key = val[0];
      if (Array.isArray(key)) {
        key = key.join(",");
      }
      key = key + "_" + type;
      this.data.common_action_json[key] = {
        val,
        type,
      };
    }
  }
}